<div
   tooltipClass="tooltip-popup"
   kendoTooltip
   [tooltipTemplate]="dialog"
   [isTooltipVisible]="isDialogOpen"
   #duplicateDialogPopupControl
   #duplicateDialogTooltipDirective="kendoTooltip"
   showOn="none"
   position="top"
   class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width"
>
   <ng-content></ng-content>
</div>

<ng-template #dialog>
   <div (samwebOutsideClick)="closeDialog($event)">
      <ng-content select="[dialog]"></ng-content>
   </div>
</ng-template>
